import React, { ReactNode } from 'react';
import { FormSummaryInfo } from '../FormSummaryInfo';
import { FinanceProgramForm } from '../../../../../schema';

interface Props {
  financeProgramFormValues: FinanceProgramForm['program'];
  isLenderCreditAppSettingVisible?: boolean;
}

export const ProgramDetailsSummaryPart = ({
  financeProgramFormValues: program,
  isLenderCreditAppSettingVisible = false,
}: Props) => {
  const renderConfiguration: Record<string, ReactNode> = {
    'Finance Program Name': program.first.details.name,
    'Finance Program Display Name': program.first.details.displayName,
    'Select Lender(s)': program.first.details.lenders?.length
      ? program.first.details.lenders?.map(({ label }) => label)?.join(', ')
      : null,
    ...(isLenderCreditAppSettingVisible && {
      'Link to Lender Credit App': program.first.details.linkToLenderCreditApp ? 'Yes' : 'No',
    }),
  };

  return <FormSummaryInfo data={renderConfiguration} />;
};
